import { TIMELINE } from '@/data/events';

import styles from './HomeTimeline.module.css';

export default function HomeTimeline() {
  return (
    <div className={styles.root}>
      {TIMELINE.map((row) => (
        <div className={styles.row} key={row.y}>
          <span className={styles.year}>{row.y}</span>
          <span className={styles.text}>{row.t}</span>
        </div>
      ))}
    </div>
  );
}
